import request from '@/utils/request';

// 忘记密码
export function findPass(query) {
  return request({
    url: '/lock/gmwebapi/retrievePassword',
    method: 'put',
    data: query,
  });
}

// 修改手机号
export function updatePhone(query) {
  return request({
    url: '/lock/gmwebapi/updatePhone',
    method: 'put',
    data: query,
  });
}

// 修改姓名
export function ApiUpdateUserName(query) {
  return request({
    url: '/lock/gmwebapi/updateUserName',
    method: 'put',
    data: query,
  });
}

// 绑定手机号
// export function bindPhone(query) {
//   return request({
//     url: '/lock/apartwebapi/sysUser/bindPhone',
//     method: 'post',
//     data: query,
//   });
// }

// 修改密码
export function updatePassWord(query) {
  return request({
    url: '/lock/gmwebapi/updatePassword',
    method: 'put',
    data: query,
  });
}

// 修改头像
// export function updateHeader() {
//   return process.env.VUE_APP_BASE_API + '/lock/apartwebapi/sysUser/lockUpload/updateHeader';
// }

// 获取当前用户信息
export function getUserInfo(query) {
  return request({
    url: '/lock/apartwebapi/sysUser/userInfo',
    method: 'get',
    params: query,
  });
}
